import type { CompetitionData, GetActiveCompetitionsResponse } from "../../../components/ActiveCompetitions/types";
import { createAppAsyncThunk } from "../../hooks";
import {
  MULTI_PRIZE_COMPETITION_ID,
  SINGLE_PRIZE_COMPETITION_ID,
  USE_CATEGORIES_MOCKS,
} from "../api/winnersFeed.mocks";

type MockCompetition = Partial<CompetitionData> &
  Pick<CompetitionData, "CompetitionId" | "IsSinglePrizeMode" | "ImageUrl">;

const MOCK_MULTI_PRIZE: MockCompetition = {
  CompetitionId: MULTI_PRIZE_COMPETITION_ID,
  IsSinglePrizeMode: false,
  ImageUrl: "https://cdn.botb.com/media/hvrnsnbm/botb-11196-comp-card_1.webp",
  Title: "iPhone 17 & 1,249+ Prizes!",
  CompetitionTypePrefix: "SC",
  NavigationColour: "navigation-turquoise",
};

const MOCK_SINGLE_PRIZE: MockCompetition = {
  CompetitionId: SINGLE_PRIZE_COMPETITION_ID,
  IsSinglePrizeMode: true,
  ImageUrl: "https://cdn.botb.com/media/ob2bk3qw/botb-12066-competition-card-342x212.webp",
  Title: "BMW M3 Competition",
  CompetitionTypePrefix: "DC",
  NavigationColour: "navigation-red",
};

export const setActiveCompetitions = createAppAsyncThunk("categories/setActiveCompetitions", async (_, thunkAPI) => {
  if (USE_CATEGORIES_MOCKS) {
    return {
      categories: [],
      competitions: [MOCK_MULTI_PRIZE as CompetitionData, MOCK_SINGLE_PRIZE as CompetitionData],
    } satisfies GetActiveCompetitionsResponse;
  }
  const response = await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000002/appv2/getactivecompetitions`, {
    credentials: "include",
    signal: thunkAPI.signal,
  });
  return response.json() as Promise<Awaited<GetActiveCompetitionsResponse>>;
});
